import { DestroyRef, Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CustomRouteService } from 'src/app/pages/custom-route/services/custom-route.service';
import { RegisterUserService } from 'src/app/pages/register-user/services/register-user.service';
import { SessionStorageService } from 'src/app/services/session-storage.service';
import { getNumberOfDaysBeetWeenStringDates } from './helpers/date.utils';
import { EMPTY, filter, first, switchMap, tap } from 'rxjs';
import { isCustomRouteResponseCompleted } from 'src/app/pages/custom-route/interfaces/custom-route.response';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RegisterUserForm } from 'src/app/pages/register-user/interfaces';

@Injectable({ providedIn: 'root' })
export class GenerateRouteService {
  private registerUser = inject(RegisterUserService);
  private customRoute = inject(CustomRouteService);
  private session = inject(SessionStorageService);
  private router = inject(Router);
    
  public sendData(formValues: RegisterUserForm, destroyRef: DestroyRef, navigateTo: string) {
    const days = getNumberOfDaysBeetWeenStringDates(
      formValues.startDate as unknown as string,
      formValues.endDate   as unknown as string
    );
    this.registerUser.setRegisterUserFormData(formValues);
    this.registerUser.setNumberOfDaysCustomRoute(days + 1);

    return this.registerUser.sendRegisterUserData(formValues).pipe(
      switchMap(res => {
        this.customRoute.setToken(res.token);
        this.session.setItem('customRouteToken', res.token);
        this.session.setItem('dayToShowIndex', 0);
        return this.customRoute.launchRoutePlanning(res.token, 0).pipe(
          filter(isCustomRouteResponseCompleted),
          first()
        );
      }),
      switchMap(completedResp => {
        if (completedResp.status !== 200) return EMPTY;
        const token = this.session.getItem<string>('customRouteToken');
        return this.customRoute.getCustomRouteResponse(token, this.customRoute.currentOrder());
      }),
      tap((res: any) => {
        if (!res.dailyRoutes.points.length) {
          console.error('TOOLS: Error en la generación de ruta');
          return;
        }
        this.customRoute.addDailyRoute(res);
        this.session.setItem('customRouteData', this.customRoute.customRouteData());
        this.customRoute.setCurrentOrder(this.customRoute.currentOrder() + 1);
        this.session.setItem('customRouteCurrentOrder', this.customRoute.currentOrder());
        this.router.navigate([navigateTo]);
      }),
      takeUntilDestroyed(destroyRef)
    );
  }
}